import { Alert, Box, Button, Paper, Skeleton } from "@mui/material";

export const ConsumptionSkeletons = () => (
	<Box
		aria-label="Loading water consumption"
		sx={{ display: "grid", gap: 1, minWidth: 0, width: "100%" }}
	>
		<Box
			sx={{
				containerType: "inline-size",
				minWidth: 0,
			}}
		>
			<Box
				sx={{
					display: "grid",
					gap: 1,
					gridTemplateAreas: '"comparison" "totals" "efficiency" "chart"',
					gridTemplateColumns: "minmax(0, 1fr)",
					minWidth: 0,
					maxWidth: "100%",
					"@container (min-width: 600px)": {
						gridTemplateAreas:
							'"comparison comparison" "totals efficiency" "chart chart"',
						gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
					},
					"@container (min-width: 1400px)": {
						gridTemplateAreas: '"comparison totals efficiency chart"',
						gridTemplateColumns:
							"minmax(340px, 1.4fr) repeat(2, minmax(320px, 1.5fr)) minmax(400px, 2fr)",
					},
				}}
			>
				<Paper variant="outlined" sx={{ gridArea: "comparison", p: 1 }}>
					<Skeleton height={190} variant="rounded" />
				</Paper>
				{["totals", "efficiency"].map((area) => (
					<Paper key={area} variant="outlined" sx={{ gridArea: area, p: 1 }}>
						<Skeleton height={190} variant="rounded" />
					</Paper>
				))}
				<Paper
					variant="outlined"
					sx={{ gridArea: "chart", minWidth: 0, p: 0.75, width: "100%" }}
				>
					<Skeleton height={190} variant="rounded" />
				</Paper>
			</Box>
		</Box>
		<Paper
			variant="outlined"
			sx={{ display: "grid", gap: 1, minWidth: 0, p: 1 }}
		>
			<Box
				sx={{
					display: "flex",
					flexWrap: "wrap",
					justifyContent: "space-between",
					gap: 1,
				}}
			>
				<Box sx={{ display: "grid", gap: 0.5 }}>
					<Skeleton height={22} variant="rounded" width={144} />
					<Skeleton height={16} variant="rounded" width={220} />
				</Box>
				<Skeleton height={28} variant="rounded" width={104} />
			</Box>
			<Box
				sx={{
					display: "flex",
					flexWrap: "wrap",
					gap: 1,
					minWidth: 0,
				}}
			>
				{[92, 120, 38, 38, 76].map((width, item) => (
					<Skeleton key={`${width}-${item}`} height={36} width={width} />
				))}
			</Box>
			<Box
				sx={{
					display: "grid",
					gap: 1,
					gridTemplateColumns: {
						xs: "minmax(0, 1fr)",
						lg: "minmax(0, 2fr) minmax(280px, 1fr)",
					},
					minWidth: 0,
				}}
			>
				<Skeleton height={260} variant="rounded" />
				<Skeleton height={260} variant="rounded" />
			</Box>
		</Paper>
	</Box>
);

export const ConsumptionError = ({
	message,
	subject = "Water consumption",
	onRetry,
}: {
	message: string;
	subject?: string;
	onRetry: () => void;
}) => (
	<Alert
		severity="error"
		action={
			<Button color="inherit" onClick={onRetry} size="small">
				Retry
			</Button>
		}
		sx={{ mb: 1 }}
	>
		{subject} could not be loaded. {message}
	</Alert>
);
